import { createBrowserHistory as createHistory } from 'history'
import Router from './Router'
import { BrowserRouterProps } from './types'

function BrowserRouter(props: BrowserRouterProps) {
  const history = createHistory(props)
  const { children, forceNewWindow, forceDomain } = props
  return (
    <Router history={history} forceNewWindow={forceNewWindow} forceDomain={forceDomain}>
      {children}
    </Router>
  )
}

export default BrowserRouter
